import styled from 'styled-components';
import { Descriptions } from 'antd';

export const StyledDescription = styled(Descriptions)`
  .ant-descriptions-item-container {
    align-items: start !important;
    .ant-descriptions-item-label {
      color: rgba(92, 101, 110, 1);
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
    }
    .ant-descriptions-item-content {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }
  .ant-descriptions-row > td {
    padding-bottom: 18px;
  }
  .ant-descriptions-item-container {
    min-height: 24px;
    align-items: center;
  }
`;
